<template>
  <div class="main">
    <div class="select-container">
      <select name="selected-pool" class="selected-pool" v-model="selectedPool" @change="getUsers()">
        <option v-for="pool in pools" :value="pool" :key="pool.id">{{ pool.name }}</option>
      </select>
    </div>
    <h1>Getränke-Historie</h1>
    <div class="select-user-container">
      <select name="selected-user" id="selected-user" class="frosted" v-model="selected_user" @change="userChanged()">
        <option v-for="user in available_users" :value="user" :key="user.user_id">{{user.name}}</option>
      </select>
    </div>
    <div v-if="!loading && (!this.pools || this.pools.length === 0)" class="center-msg">
      <h3>Du bist noch kein Mitglied in einer Gruppe!</h3>
      <p>Tritt auf der Startseite zuerst einer Gruppe bei.</p>
    </div>
    <div v-if="!loading && (!this.logged_drinks || this.logged_drinks.length === 0) && (this.pools && this.pools.length > 0)" class="center-msg">
      <h3>Noch keine Getränke eingetragen.</h3>
    </div>
    <LoadingSpinner  v-if="loading" message="Getränke werden geladen..." class="center-msg"/>
    <div class="logged-drinks-list">
      <div class="logged-drink frosted" v-for="drink in logged_drinks" :key="drink.log_id" @click="selectLog(selected_user.is_active_user ? drink : null)">
        <div class="info left">
          <h2>{{drink.log_drink_name}}</h2>
          <p>{{drink.log_timestamp}}</p>
        </div>
        <div class="info right">
          <p><b>{{drink.log_ml}}</b>ml <b>{{drink.log_vol}}</b>%vol</p>
          <p v-if="drink.log_alcohol_amount && drink.log_alcohol_amount > 0"><b>{{drink.log_alcohol_amount}}</b>g Alkohol</p>
          <p v-else><b>0</b>g Alkohol 😕</p>
        </div>
      </div>
    </div>
    <div class="edit-log-container" v-if="selected_log">
      <div class="edit-log-form" v-if="selected_log && !staged_delete">
        <div class="back-button-container">
          <button class="back-button" @click="resetModal();">
            <img src="@/assets/images/back.svg">
          </button>
          <h2>Eintrag bearbeiten</h2>
        </div>
        <h3>{{selected_log.log_drink_name}}</h3>
        <label for="new-drink-default-ml"><p>ml</p></label>
        <input type="text" id="new-drink-default-ml" v-model="selected_log.log_ml">
        <label for="new-drink-default-vol"><p>vol%</p></label>
        <input type="text" id="new-drink-default-vol" v-model="selected_log.log_vol">
        <p style="text-align: right;"><b>{{calculatePureAlcohol(selected_log.log_ml, selected_log.log_vol)}} g</b> reiner Alkohol</p>
        <p v-if="modal_msg">{{modal_msg}}</p>
        <div class="button-container">
          <button class="danger" @click="stageDeletion(selected_log)"><p>Löschen</p></button>
          <button class="normal" @click="updateDrink" :disabled="submitting"><p>{{submitting ? 'Wird gespeichert...' : 'Speichern 🍺'}}</p></button>
        </div>
      </div>
      <div class="delete-log-container" v-if="staged_delete">
        <button class="back-button" @click="resetModal();">
          <img src="@/assets/images/back.svg">
        </button>
        <h3>Sicher, dass der Eintrag gelöscht werden soll?</h3>
        <p>Das lässt sich nicht rückgängig machen.</p>
        <div class="button-container">
          <button class="danger" @click="deleteLog()"><p>Ja, Löschen.</p></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService.js';
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import moment from "moment";
export default {
  "name": "VoteOverview",
  data() {
    return {
      isAdmin: false,
      votes: null,
      pools: null,
      loading: false,
      logged_drinks: null,
      available_users: null,
      selected_user: null,
      selected_log: null,
      staged_delete: null,
      submitting: false,
      modal_msg: null,
      msg: null
    }
  },
  computed: {
    selectedPool: {
      get() {
        return this.$store.getters.getSelectedPool;
      },
      set(val) {
        this.$store.commit('SET_SELECTED_POOL', val);
      }
    }
  },
  components: {
    LoadingSpinner
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
    selectLog(log){
      this.selected_log = log;
      console.log(this.selected_log);
    },
    resetModal() {
      this.selected_log = null
      this.staged_delete = null
    },
    stageDeletion(log){
      this.staged_delete = log;
    },
    async deleteLog() {
      try {
        let result = await AuthService.deleteLog({
          pool_id: this.selectedPool.pool_id,
          log_id: this.selected_log.log_id
        })

        if(result.success) {
          this.$router.go();
        } else {
          this.modal_msg = result.msg
        }
      } catch(e) {
        console.error(e)
        this.modal_msg = "API-Fehler: " + JSON.stringify(e.response.data.msg);
      }
    },
    async updateDrink() {
      this.submitting = true
      if(!this.selected_log.log_vol || !this.selected_log.log_ml || !(this.selected_log.log_drink_name || this.selected_drink.drink_name)) {
        this.modal_msg = "Getränkename, ml und vol% Angabe sind erforderlich!"
        this.submitting = false
        return
      } else if (this.selected_log.log_vol < 0 || this.selected_log.log_ml < 0) {
        this.modal_msg = "Negative Werte gehen nicht du Schlingel"
        this.submitting = false
        return
      }

      try {
        let result = await AuthService.updateLog({
          pool_id: this.selectedPool.pool_id,
          log_id: this.selected_log.log_id,
          log_vol: this.selected_log.log_vol,
          log_ml: this.selected_log.log_ml,
          log_alcohol_amount: this.calculatePureAlcohol(this.selected_log.log_ml, this.selected_log.log_vol),
        })

        if(result.success) {
          this.$router.go();
        } else {
          this.modal_msg = result.msg
        }
      } catch(e) {
        console.error(e)
        this.modal_msg = "API-Fehler: " + JSON.stringify(e.response.data.msg);
      }
      this.submitting = false
    },
    async getDrinks(user_id) {
      this.loading = true;
      try {
        let result = await AuthService.getUserLoggedDrinks({pool_id: this.selectedPool.pool_id, user_id: user_id});
        if(result.success) {
          this.logged_drinks = this.formatDrinksList(result.msg);
        } else {
          this.errorMsg = result.msg
        }
      } catch(e) {
        console.error(e)
        this.errorMsg = e.response.data.msg
      }
      this.loading = false;
    },
    calculatePureAlcohol(ml, vol){
      // this is based on this: https://zsgw.rptu.de/campusplus/gesundheit/wissen/alkohol/promillerechner#:~:text=%2D%20In%20einem%20halben%20Liter%20Bier,6%20Gramm%20reiner%20Alkohol%20enthalten.
      return (ml && vol) ? Math.round(((ml * (vol / 100) * 0.8) + Number.EPSILON) * 100) / 100 : 0
    },
    async getUsers() {
      try {
        let result = await AuthService.getUsersInPool({pool_id: this.selectedPool.pool_id});
        if(result.success) {
          this.formatAvailableUsers(result.msg);
          await this.getDrinks(this.selected_user.user_id)
        } else {
          this.errorMsg = result.msg
        }
      } catch(e) {
        console.error(e)
        this.errorMsg = e.response
      }
    },
    userChanged(){
      this.getDrinks(this.selected_user.user_id)
    },
    formatAvailableUsers(data){
      this.available_users = data.map(d => { return {user_id: d.id, name: (d.name ?? d.email) + (d.id === this.$store.getters.getUser.id ? ' (Du)' : ''), is_active_user: d.id === this.$store.getters.getUser.id}})
      this.selected_user = this.available_users.find(d => d.is_active_user)
    },
    formatDrinksList(data) {
      return data.sort((a, b) => a.log_timestamp ? (moment(a.log_timestamp).isSameOrBefore(moment(b.log_timestamp))) : true).map(d => {return {...d, "log_timestamp": d.log_timestamp ? moment.utc(d.log_timestamp).format("DD.MM.Y HH:mm") : null}})
    },
    async getUserJoinedPools() {
      this.loading = true

      try {
        this.msg = await AuthService.getUserJoinedPools()
        if (this.msg.success && this.msg.msg.length > 0) {
          this.pools = this.msg.msg
          
          // Check if previously selected pool is still available
          const persistedPool = this.selectedPool;
          if (persistedPool) {
            const persistedId = persistedPool.pool_id || persistedPool.id;
            const found = this.pools.find(p => (p.pool_id || p.id) === persistedId);
            if (found) {
              this.selectedPool = found;
              return;
            }
          }

          this.selectedPool = this.msg.msg[0]
        }
      } catch (e) {
        console.error(e)
        this.errorMsg = e.response.data.msg
      }

      this.loading = false
    },
  },
  async beforeCreate() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login');
    }
  },
  async mounted() {
    try {
      this.msg = await AuthService.getUser()
      this.isAdmin = !!this.msg.msg.isAdmin;
    } catch(e){
      console.error(e)
    }

    await this.getUserJoinedPools()
    await this.getUsers()
  }
}
</script>
<style scoped>
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  max-height: 100vh;
  background: var(--background);
  padding: 20px;
  overflow-y: hidden;
}

h1 {
  font-size: 1.8rem;
  margin: 10px 0 20px 0;
  text-align: center;
  width: 100%;
  max-width: 600px;
}

h2 {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
}

h3 {
  font-size: 1.2rem;
  margin-bottom: 10px;
}

p {
  color: var(--tertiary-color);
  margin: 0;
}

/* Selects */
.select-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
  width: 100%;
  max-width: 600px;
}

.selected-pool {
  font-size: 1.5rem;
  font-family: var(--font);
  font-weight: 700;
  background: none;
  border: none;
  color: var(--primary-color);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
  text-align: center;
  text-align-last: center;
}

.select-container img {
  transform: rotate(-90deg);
  width: 16px;
  height: 16px;
  opacity: 0.5;
}

.select-user-container {
  width: 100%;
  max-width: 600px;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.select-user-container select {
  background: var(--background-secondary);
  border: none;
  color: var(--primary-color) !important;
  border-radius: var(--radius-m);
  padding: 10px 15px;
  font-family: var(--font);
  font-size: 1rem;
  width: 100%;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

/* List */
.logged-drinks-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 600px;
  overflow-y: auto;
  padding-bottom: 100px;
}

.logged-drink {
  background: var(--background-secondary);
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  padding: 15px 20px;
  border-radius: var(--radius-m);
  transition: background 0.2s;
  cursor: pointer;
}

.logged-drink:active {
  background: var(--active-bg);
}

.logged-drink h2 {
  font-size: 1.1rem;
  color: var(--primary-color);
}

.logged-drink p {
  font-size: 0.85rem;
}

.logged-drink .info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.logged-drink .info.right {
  text-align: right;
  min-width: 100px;
}

.logged-drink .info.right p b {
  color: var(--primary-color);
}


/* Edit Modal */
.edit-log-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2000;
  background: rgba(0,0,0,0.4);
  backdrop-filter: blur(5px);
}

.edit-log-form, .delete-log-container {
  background: var(--background);
  padding: 30px;
  border-radius: var(--radius-l);
  width: 90%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.2);
}

.edit-log-form input {
  font-size: 1.2rem;
  border: none;
  border-radius: var(--radius-m);
  padding: 12px;
  background-color: var(--background-secondary);
  color: var(--primary-color);
  width: 100%;
}

.edit-log-form p {
  text-align: left;
}

.back-button-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.back-button {
  background: none;
  padding: 0;
  margin: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-button img {
  width: 24px;
  height: 24px;
  filter: var(--icon-filter);
}

.button-container {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: stretch;
  margin-top: 10px;
}

.button-container button {
  flex: 1;
  padding: 15px;
  border-radius: var(--radius-m);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
}

button p {
  text-align: center !important;
}

button.normal {
  background: var(--primary-color);
  color: var(--text-on-primary);
}

button.danger {
  background: var(--background-secondary);
}

button.danger p {
  color: var(--warning);
}

.center-msg {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50vh;
  text-align: center;
  margin-top: 0;
}
</style>
